<script>
import Vue from "vue";
import CheckoutForm from "../CheckoutForm.vue";
import DeluxeLeft from "./DeluxeLeft";
import Footer from "../../Footer.vue";
import Testimonial from "../Testimonial.vue";

export default {
  name: "DeluxeCheckout",
  page: {
    title: "Dropsmart Deluxe Checkout",
    meta: [{ name: "description", content: "Dropsmart Deluxe Checkout Page." }]
  },
  components: {
    DeluxeLeft,
    CheckoutForm,
    Footer,
    Testimonial
  },
  mounted: function() {
    console.log('Redirecting to pricing page');
    window.location = "https://dropsmarteo.com/pricing";
  },
  data: function() {
    return {
      changeBus: new Vue(),
      guaranteeImg: "ssl-cancel-anytime.jpg",
      expirationDate: new Date('21 April 2021 09:00:00 GMT+0100'),
      testimonials: {
        katja: {
          photo: "powerdrops/testimonial-katja-zmitek.png",
          name: "Katja Žmitek",
          quote: `Dropsmart makes preparing essential oil chemistry class for my university students easier. The abundant amount of useful information is well organised, straightforward as well eye-pleasing.`
        },
        carol: {
          photo: "powerdrops/testimonial-carol-rose.png",
          name: "Carol Rose",
          quote: `A stand-out feature of Dropsmart is direct access to a wealth of evidence-based research about essential oils and their components. An in-depth resource, invaluable for my research, publications and course preparations as well as the global aromatherapy community.`
        },
        jody: {
          photo: "powerdrops/testimonial-jody.png",
          name: "Jody Elleaume",
          quote: `I met Melani during a seminar in Provence (France) where her lectures and contribution was greatly appreciated for her professionalism and relevance. She manages to make aromatic biochemistry accessible to everyone in a practical and fun way. Her work is so good that I recommend Dropsmart site to all my students at Myrtéa formations my school of aromatherapy in France.`
        },
        rosemerie: {
          photo: "powerdrops/testimonial-rosemarie-rosa.png",
          name: "Rosemarie Rosa Ilic",
          quote: `Melani and Dropsmart thrilled me with their essential oils information, supplier and distillery information, and notably their research and access to numerous scientific publications.
I followed Melani's activities and her contribution to Aromatherapy a long time before I met her at the 2019 AIA International Aromatherapy Conference while attending her workshop ‘Connecting the Dots in Aroma Chemistry’. As a chemist, I am critical of the approach to how the chemistry of essential oils is presented and taught, but this time I was satisfied, with Melani’s simple yet interesting demonstration and the logical application of essential oils (aroma) chemistry.
Also, from a U.S. point of view, I appreciate Melani’s and Dropsmit’s efforts to unite the individual aromatherapies across countries and continents.`
        },
        ruta: {
          photo: "powerdrops/testimonial-ruta-aldonyte.png",
          name: "Ruta Aldonyte",
          quote: `We are extremely grateful for this transfer of knowledge. It is a very new view point in aromatherapy: not based on books but on live constantly growing scientific database of knowledge and on precise chemical blueprint of each individual oil. This brings long awaited novel approach into knowing and using our beloved essential oils. It was a breakthrough for us and we greatly appreciate your effort to bring it to us.`
        },

      }

    };
  }
};
</script>

<template>
  <b-container style="background-color: white; padding: 0 3rem 0 3rem">
    <b-row>
      <b-col sm="12" class="logo-row header-checkout">
        <div>
          <img src="@/assets/images/dropsmart-logo.png" alt="Dropsmart Logo" class="logoCheckout" />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" class="call-to-action-row header-checkout">
        <div class="call-to-action">
          <h2>Launching Deluxe Plan</h2>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" class="time-counter-row header-checkout">
        <countdown :end-time="expirationDate.getTime()">
          <template v-slot:process="deluxeCountdown">
            <div class="time-counter">
              <div id="time-counter-container">
                <div>
                  <div class="value">{{ deluxeCountdown.timeObj.d }}<span>|</span></div>
                  <div class="label">days</div>
                </div>
                <div>
                  <div class="value">{{ deluxeCountdown.timeObj.h }}<span>:</span></div>
                  <div class="label">hours</div>
                </div>
                <div>
                  <div class="value">{{ deluxeCountdown.timeObj.m }}<span>:</span></div>
                  <div class="label">minutes</div>
                </div>
                <div>
                  <div class="value">{{ deluxeCountdown.timeObj.s }}</div>
                  <div class="label">seconds</div>
                </div>
              </div>
            </div>
          </template>
          <!--template v-slot:finish>
            <div style="margin: 0 0 2rem 0;">
            <a id="expired-offer-link" href="https://dropsmarteo.com/pricing">I'M SORRY. THIS OFFER IS CLOSED! You have to wait for the next group.</a>
            </div>
          </template -->
        </countdown>
      </b-col>
    </b-row>
    <b-row class="checkout-content">
      <b-col sm="12" lg="6" class="content" style="text-align: left">
        <deluxeLeft />
      </b-col>
      <b-col sm="12" lg="6" class="checkout">
        <CheckoutForm :loadCombos="[10]" :guaranteeImg="guaranteeImg" :changeBus="changeBus" :discount="'50%'" :expirationDate="expirationDate" class="h-100" />
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col sm="12" lg="12">
        <b-card no-body>
          <b-row>
            <b-col md="4">
              <b-card class="text-center" border-variant="light" style="padding-top: 1.75rem">
                <b-card-img
                  img-top
                  :src="require('@/assets/powerdrops/thumb-melani.png')"
                  style="height: 90px; width: 90px; display: block; margin: auto"
                />
                <b-card-title title="Melani Kovač"></b-card-title>
                <b-card-body class="text-center"
                  >Dropsmart's founder, Aromatherapist and Lecturer at Higher school of applied sciences</b-card-body
                >
              </b-card>
            </b-col>
            <b-col md="8">
              <b-card-body style="line-height: 1.5em; font-size: 1.2em; padding: 2rem">
                <h5 style="font-weight: bold">Your teacher</h5>
                <p>
                  Melani Kovač devoted her last 13+ years solely to promoting aromatherapy. To serve this purpose she’s founded
                  Aromainstitut through which she organises and supports different aromatherapy projects, collaborates with colleagues,
                  non-profit organisations, homes for the elderly, hospitals, universities and anyone who can benefit from aromatherapy or
                  is hoping to incorporate aromatherapy in their work. Her IT background, curiosity as well as working as an educator for a
                  very wide variety of students along with collaborating with distillers, sellers, nurses and scientists inspired her to
                  create a global online platform for all essential oil users and sellers - Dropsmart. Her goal is to make aromatherapy
                  simple, fun and as precise and as safe as possible.
                </p>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="text-center" style="margin: 2rem 0 2rem 0">
        <br/><br/>
        <h2 style="font-weight: 600; text-transform: uppercase">your aromatherapy problems are over</h2>
        <br/>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="2">
      </b-col>
      <b-col md="8" style="font-size: 1.3em;">
        <p>Dropsmart Deluxe Plan gives you all the incredible benefits from a Premium user plus 4 exclusive lectures per year with Melani Kovac (Dropsmart's founder).</p>
        <br/>
        <p>Melani designed the 4 lectures to help everyone that works with Aromatherapy to become more knowledgeable.</p>
        <br/>
        <p>If you are starting your journey or have 15+ years of experience as an aromatherapist, Dropsmart Deluxe Plan is for you.</p>
        <br/>
        <p>With these lectures plus access to all the premium features of Dropsmart, you will have a professional tool and a unique perspective of Aromatherapy that you can implement instantaneously.</p>
        <br/>
        <p>Melani will teach an efficient way to <strong>help your family and clients</strong> and have the <strong>power you are looking for</strong> to pursue Aromatherapy further.</p>
        <ol>
          <li><strong>Dropsmart and the lectures are NOT hard to understand</strong> due to Melani's didactics and her wide experience of the chemistry of essential oils. She explains this subject in an effortless and colorful way so everyone can follow;</li>
          <li><strong>We DO NOT add more confusion to your mind</strong> caused by the contradictions you find out there (sometimes from EO brands, the Internet, books, Facebook groups, etc...);</li>
          <li><strong>You CAN NOT find it anywhere else</strong> because this is a compilation of 13+ years of Melani's unique knowledge. You will know what to look out for and where to turn to for safe, trustworthy, and relevant information.</li>
        </ol>
        <br/>
        <p>Aromatherapy is getting bigger, and more people are using it every single day. Here you find information that you can trust, rely on, and make good choices combining everything you already know with what Dropsmart Deluxe can offer to you.</p>        
        <br/>
        <p><strong>Don't take only my words. Here is what people say about Dropsmart and Melani:</strong></p>
        <br/>
        <div class="testimonials">
          <Testimonial :testimonial="testimonials.katja" />
          <Testimonial :testimonial="testimonials.carol" />
          <Testimonial :testimonial="testimonials.jody" />
          <Testimonial :testimonial="testimonials.rosemerie" />
          <Testimonial :testimonial="testimonials.ruta" />
        </div>
        <br/>
        <br/>
        <p>And these are only a few examples of thousands of users, customers and students we have...</p>
        <br/>
        <p>By joining the Dropsmart Deluxe, you will experience by yourself all these fantastic things everyone says about us.</p>
        <br/>
        <p>Everything you will discover with Dropsmart and with the lectures you will be able to apply immediately on your daily basis.</p>
        <br/>
        <p>Melani created Dropsmart for everyone who uses essential oils to make better decisions because she understood how hard it is to put all the information you find about aromatherapy together and make sense of it.</p>
        <br/>
        <p><strong>Now, with Dropsmart Deluxe, it is easy, simple, and inspiring!</strong></p>
        <br/>
        <p>You will feel powerful, sophisticated, and still be original in your choices. You don't need to keep following what other people say.</p>
        <br/>
        <p><strong>This is your chance to be authentic, to be yourself.</strong></p>
        <br/>
        <p><i>Claim your 50% discount TODAY and be part of the selective group of aromatherapists by joining our Dropsmart Deluxe Plan.</i></p>
      </b-col>
      <b-col md="2">
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div style="margin-top: 3rem; text-align: center">
          <button
            class="button-checkout"
            style="max-width: 22em"
            v-scroll-to="'#time-counter-container'"
            @click="changeBus.$emit('start-filling-form')"
          >
            <span id="button-text">i want to claim my 50% discount</span>
          </button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="text-center">
        <div style="margin-top: 2rem">
          <h2 style="font-weight: 600; font-size: 1.5em; margin-top: 2em">You can cancel at any time. No hard feelings.</h2>
        </div>
      </b-col>
    </b-row>
    <Footer />
  </b-container>
</template>

<style lang="scss">
$vs-state-active-bg: #f7f7f7;
$vs-state-active-color: #444;

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

// Form Settings
$border-input: 1px solid #f7f7f7;
$bg-input: #f7f7f7;
$color-input: #000000;
$font-size-input: 18px;
$color: #000000;
$line-height-input: 23px;
$padding-input: 15px 18px 15px 55px;
$link-color: #68a432;

// Icon Settings
$icon-color: #999999;

* {
  font-family: $font-family;
}

.alert-error {
  color: #ff0000;
  font-size: 16px;
  margin: 0 !important;
  padding: 0 !important;
  text-align: center;
}

.header-checkout {
  text-align: center;
  h2 {
    font-size: 36px !important;
    font-weight: 600;
    color: black ;
  }
}
@media screen and (min-width: 481px) {
  /*.header-checkout:before {
    content: url(../../../assets/images/img-icons.png);
    position: absolute;
    right: 0;
    pointer-events: none;
  }*/
}
.checkout-content {
  padding-bottom: 0;
  margin-bottom: 0;
  display: flex;
  align-items: stretch;
}

.logo-row {
  margin: 65px 0 0;
  .logoCheckout {
    width: 100%;
    max-width: 228px !important;
    margin: 0 auto;
  }
}
.call-to-action {
  margin: 50px 0 10px;
  height: 80px;
  background-image: url(../../../assets/powerdrops/call-to-action-background.png);
  background-size: contain;
  background-repeat: no-repeat;
}
.call-to-action h2 {
  font-family: "OpenSans";
  font-size: 36px;
  color: #b8b8b8;
  text-transform: uppercase;
  line-height: 1.3;
}

#time-counter-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 40px 0;
}

#time-counter-container div {
  width: 3em;
  font-size: 3rem;
  font-weight: 400;
}
#time-counter-container span {
  float: right;
}
#time-counter-container .value {
  height: 60px;
}
#time-counter-container .label {
  font-weight: normal;
  font-size: 0.9rem;
  width: auto;
  text-align: center;
  text-transform: uppercase;
  color: #555;
}

#bonus-left {
  font-size: 1.05rem;
  line-height: 2.75em;
}

ul#bonus-left > li {
  font-weight: bold;
  list-style: disc;
}
ul#bonus-left > li li {
  font-weight: normal;
  list-style: disc;
}

ul#bonus-right {
  line-height: 2.75em;
  width: 88%;
}

ul#bonus-right > li {
  font-weight: bold;
  list-style: disc;
}

ul#bonus-right > li li {
  font-weight: normal;
  line-height: 1em;
  margin-bottom: 2rem;
  list-style: disc;
}

ul#bonus-right h4 {
  font-size: 1.1rem;
  margin-bottom: 6px;
  margin-top: 16px;
}
#expired-offer-link {
  font-size: 1.5rem;
  color: red;
  font-weight: 900;
}

#expired-offer-link:hover {
  color: red;
  text-decoration: underline;
}
#expired-offer-link:visited {
  color: red;
  text-decoration: none;
}
</style>
